import { render, staticRenderFns } from "./UserModal.vue?vue&type=template&id=30b1585d"
import script from "./UserModal.vue?vue&type=script&lang=js"
export * from "./UserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports